export default function PHP_ucwords() {
  return (
    <div>
      <h1>PHP_ucwords</h1>
    </div>
  );
}
